import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { useAuthActions, useIsAuthenticated, useUser } from './store';
import { authApi } from './services/api';

// Components
import LoginPage from './components/LoginPage';
import Dashboard from './components/Dashboard';
import InventoryPage from './components/InventoryPage';
import PurchaseOrdersPage from './components/PurchaseOrdersPage';
import UnmatchedPage from './components/UnmatchedPage';
import ReportsPage from './components/ReportsPage';
import BatchCounterPage from './components/BatchCounterPage';
import Layout from './components/Layout';
import LoadingSpinner from './components/LoadingSpinner';
import ToastContainer from './components/ToastContainer';

function App() {
  const isAuthenticated = useIsAuthenticated();
  const user = useUser();
  const { setUser, setToken, setLoading } = useAuthActions();

  useEffect(() => {
    const initAuth = async () => {
      const token = localStorage.getItem('token');
      if (token) {
        setLoading(true);
        try {
          const response = await authApi.verify();
          if (response.success && response.data?.valid) {
            setUser(response.data.user);
            setToken(token);
          } else {
            // Invalid token
            localStorage.removeItem('token');
            setUser(null);
            setToken(null);
          }
        } catch (error) {
          console.error('Auth verification failed:', error);
          localStorage.removeItem('token');
          setUser(null);
          setToken(null);
        } finally {
          setLoading(false);
        }
      }
    };

    initAuth();
  }, [setUser, setToken, setLoading]);

  // Show loading spinner during auth verification
  if (user === null && localStorage.getItem('token')) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <LoadingSpinner size="large" />
      </div>
    );
  }

  return (
    <Router>
      <div className="App">
        <Routes>
          {!isAuthenticated ? (
            <>
              <Route path="/login" element={<LoginPage />} />
              <Route path="*" element={<Navigate to="/login" replace />} />
            </>
          ) : (
            <Route path="/" element={<Layout />}>
              <Route index element={<Navigate to="/dashboard" replace />} />
              <Route path="dashboard" element={<Dashboard />} />
              <Route path="inventory" element={<InventoryPage />} />
              <Route path="purchase-orders" element={<PurchaseOrdersPage />} />
              <Route path="unmatched" element={<UnmatchedPage />} />
              <Route path="batch-counters" element={<BatchCounterPage />} />
              <Route path="reports" element={<ReportsPage />} />
              <Route path="*" element={<Navigate to="/dashboard" replace />} />
            </Route>
          )}
        </Routes>
        <ToastContainer />
      </div>
    </Router>
  );
}

export default App;